module.exports = __webpack_public_path__ + "img/spin_btn.c97027c1.png";